export const enterpriceApp: Array<string> = [
    "Internal System Support",
    "Email Support",
    "Oracle Support"
]

export const userAccountManagement: Array<string> = [
    "Create New User Account",
    "User Account Update",
    "User Password Reset",
    "User's Automated Backup"
]

export const preventiveMaintenanceService: Array<string> = [
    "MIS Office Equipment",
    "MIS Store Equipment",
    "MIS Farm Equipment"
]

export const desktopSupport: Array<string> = [
    "Hardware",
    "Software",
    "Corrective Maintenance Services"
]

export const laptopSupport: Array<string> = [
    "Hardware",
    "Software",
    "Corrective Maintenance Services"
]

export const POSSupport: Array<string> = [
    "POS Hardware",
    "POS Software",
    "POS Database",
    "POS Peripherals",
    "POS Printer",
    "POS Network Connection"
]

export const NetworkConnection: Array<string> = [
    "Wired Connection",
    "Wireless Connection",
    "Network File Sharing",
];